export default "__VITE_ASSET__yv3oN2PQ__"